export default __webpack_public_path__ + "static/media/bot.fdb519ef.png";